import { createSelector } from "reselect";
import moment from "moment";
import _ from "lodash";
export const selectAllToolBoxList = ({ ToolBox_reducer }) => {
    return ToolBox_reducer.allToolBoxList;
};
export const getAllToolBoxTypes = ({ ToolBox_reducer }) => {
    return ToolBox_reducer.toolboxType;
};
export const selectProfile = ({ UserProfile_reducer }) => {
    if (UserProfile_reducer.profile) return UserProfile_reducer.profile.profile;
    else return false;
};
export const getRequesting = ({ ToolBox_reducer }) => {
    return ToolBox_reducer.requesting;
};
export const getNewID = ({ ToolBox_reducer }) => {
    return ToolBox_reducer.newID;
};
export const selectToolType = ({ ToolBox_reducer }) => {
    return ToolBox_reducer.toolType;
};
export const selectPageIndex = ({ ToolBox_reducer }) => {
    return ToolBox_reducer.pageIndex;
};
export const selectRowCount = ({ ToolBox_reducer }) => {
    return ToolBox_reducer.rowCount;
};
export const selectSortTableKey = ({ ToolBox_reducer }) => {
    return ToolBox_reducer.sortTableKey;
};
export const selectSortTableType = ({ ToolBox_reducer }) => {
    return ToolBox_reducer.sortTableType;
};
export const selectSortTableAs = ({ ToolBox_reducer }) => {
    return ToolBox_reducer.sortTableAs;
};
export const selectAllToolTypes = createSelector(
    [getAllToolBoxTypes],
    (toolboxType) => {
        if (
            toolboxType === false ||
            typeof toolboxType === "undefined" ||
            toolboxType === null
        ) {
            return [];
        }
        let toolBoxTypes = _.compact(Object.values(toolboxType));
        return toolBoxTypes;
    }
);
export const selectCompletedToolbox = createSelector(
    [selectAllToolBoxList, selectToolType],
    (toolbox = false, toolType = false) => {
        if (toolbox) {
            let completeBoxInfo = _.compact(
                Object.keys(toolbox).map((toolbox_uid) => {
                    let created_by =
                        _.get(toolbox[toolbox_uid], "profile.created_by") || "";
                    let attached_photos =
                        _.get(
                            toolbox[toolbox_uid],
                            "profile.attached_photos"
                        ) || "";
                    let icon_url =
                        _.get(toolbox[toolbox_uid], "profile.icon_url") || "";
                    let toolbox_topic =
                        _.get(toolbox[toolbox_uid], "profile.toolbox_topic") ||
                        "";
                    let category =
                        _.get(toolbox[toolbox_uid], "profile.category") || "";
                    let toolbox_id =
                        _.get(toolbox[toolbox_uid], "profile.toolbox_id") || "";
                    let created_timestamp =
                        _.get(
                            toolbox[toolbox_uid],
                            "profile.created_timestamp"
                        ) || "";
                    let points = _.get(toolbox[toolbox_uid], "points") || "";
                    let reports =
                        _.get(toolbox[toolbox_uid], "reports") || null;

                    return {
                        uid: toolbox_uid,
                        profile: {
                            created_by,
                            attached_photos,
                            icon_url,
                            toolbox_topic,
                            category,
                            toolbox_id,
                            created_timestamp,
                        },
                        points,
                        reports,
                    };
                })
            );
            if (toolType !== "all_categories") {
                completeBoxInfo = completeBoxInfo.filter((e) => {
                    return e.profile.category === toolType;
                });
            }
            return completeBoxInfo.filter((e) => {
                return e.reports !== null;
            });
        } else {
            return false;
        }
    }
);
export const selectToolbox = createSelector(
    [
        selectAllToolBoxList,
        selectToolType,
        selectSortTableType,
        selectSortTableKey,
        selectSortTableAs,
    ],
    (toolbox, toolType = false, sortType, sortKey, sortAs) => {
        if (toolbox) {
            let toolboxInfo = _.compact(
                Object.keys(toolbox).map((toolbox_uid) => {
                    let created_by =
                        _.get(toolbox[toolbox_uid], "profile.created_by") || "";
                    let attached_photos =
                        _.get(
                            toolbox[toolbox_uid],
                            "profile.attached_photos"
                        ) || "";
                    let icon_url =
                        _.get(toolbox[toolbox_uid], "profile.icon_url") || "";
                    let toolbox_topic =
                        _.get(toolbox[toolbox_uid], "profile.toolbox_topic") ||
                        "";
                    let category =
                        _.get(toolbox[toolbox_uid], "profile.category") || "";
                    let toolbox_id =
                        _.get(toolbox[toolbox_uid], "profile.toolbox_id") || "";
                    let created_timestamp =
                        _.get(
                            toolbox[toolbox_uid],
                            "profile.created_timestamp"
                        ) || "";
                    let points = _.get(toolbox[toolbox_uid], "points") || "";
                    let reports = _.get(toolbox[toolbox_uid], "reports") || "";

                    return {
                        uid: toolbox_uid,
                        profile: {
                            created_by,
                            attached_photos,
                            icon_url,
                            toolbox_topic,
                            category,
                            toolbox_id,
                            created_timestamp,
                        },
                        points,
                        reports,
                    };
                })
            );
            if (toolType !== "all_categories") {
                toolboxInfo = toolboxInfo.filter((e) => {
                    return e.profile.category === toolType;
                });
            }
            if (sortKey !== false && sortAs !== false) {
                switch (sortAs) {
                    case "string": {
                        toolboxInfo = toolboxInfo.sort((a, b) => {
                            return a.profile[sortKey]
                                .toLowerCase()
                                .trim()
                                .localeCompare(
                                    b.profile[sortKey].toLowerCase().trim()
                                );
                        });

                        break;
                    }
                    case "date": {
                        toolboxInfo = toolboxInfo.sort((a, b) => {
                            return (
                                moment(
                                    a.profile[sortKey],
                                    "DD-MM-YYYY HH:mm:ss"
                                ) -
                                moment(
                                    b.profile[sortKey],
                                    "DD-MM-YYYY HH:mm:ss"
                                )
                            );
                        });

                        break;
                    }
                    case "talks_completed": {
                        toolboxInfo = toolboxInfo.sort((a, b) => {
                            let aRep = 0,
                                bRep = 0;
                            if (a.reports) {
                                aRep = Object.keys(a.reports).length;
                            }
                            if (b.reports) {
                                bRep = Object.keys(b.reports).length;
                            }
                            return aRep - bRep;
                        });

                        break;
                    }
                    case "created": {
                        toolboxInfo = toolboxInfo.sort((a, b) => {
                            return a.profile[sortKey].user_name
                                .toLowerCase()
                                .trim()
                                .localeCompare(
                                    b.profile[sortKey].user_name
                                        .toLowerCase()
                                        .trim()
                                );
                        });

                        break;
                    }
                    default: {
                        break;
                    }
                }
            }
            // return _.orderBy(toolboxInfo, "profile.toolbox_id");
            return sortType === "asc" ? toolboxInfo : toolboxInfo.reverse();
        } else {
            return false;
        }
    }
);
